export default "__VITE_ASSET__ed04bf1d__"